"use client"
/* */
const menuItem = "flow--menu-item";
const icon = "flow--menu-item--icon";
const controlIcon = "flow--menu-item--control-icon";
const avatar = "flow--menu-item--avatar";
const styles = {
	menuItem: menuItem,
	"switch": "flow--menu-item--switch",
	icon: icon,
	controlIcon: controlIcon,
	avatar: avatar
};

export { avatar, controlIcon, styles as default, icon, menuItem };
//# sourceMappingURL=MenuItem.module.scss.mjs.map
